// @flow
export const GlobalLocale = {
  loading: ["Loading", "Yükleniyor"],
  content_loading_error: ["It seems that there is an error on loading this content...", "İçeriğin yüklenmesinde bir hata oluştu..."],
  return_to_homepage: ["Return to Homepage", "Anasayfa'ya Dön"],
  inventory_counting_page: {
    header: ["Inventory Counting Process & Technologies", "Envanter Sayım Süreç ve Teknolojileri"]
  },
  hr_solutions_page: {
    header: ["HR Solutions", "İK Çözüm Süreçlerimiz"]
  },
  partners_page: {
    header: ["Partnerships", "Partnerlik Süreçlerimiz"]
  },
  missing_content: [
    "The content for this page will be ready soon!",
    "Bu sayfanın içeriği hazırlanma aşamasında!"
  ]
};



// WEBPACK FOOTER //
// ./src/Locales/Global/Global.locale.js